<template>
  <div class="table__item">
    <div class="table__column">
      <svg @click="removeAllProductFormCart" width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 10L1 1M10 1L1 10" stroke="#2F2F2F" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="table__column table__info">
      <img :src="product.product.images.edges[0]?.node.image" :alt="product.product.name">
      <p>{{ product.product.name }}</p>
    </div>
    <div class="table__column">
      <p>€{{ product.product.price }}</p>
    </div>
    <div class="table__column">
      <div class="table__tools">
        <button class="table__tools-item table__tools-button" @click="removeProductFormCart">-</button>
        <span class="table__tools-item table__tools-count" v-text="'X' + productQuantity" />
        <button class="table__tools-item table__tools-button" @click="addProductToCart">+</button>
      </div>
    </div>
    <div class="table__column">
      <p>€{{ product.product.price * product.quantity }}</p>
    </div>
  </div>
</template>

<script setup>
import {useCartStore} from "@/stores/cart.js";
import {computed} from "vue";
import {Orders} from "@/core/api/orders.js";
import {ElNotification} from "element-plus";
import {useAuthStore} from "@/stores/auth.js";
import {useI18n} from "vue-i18n";

const props = defineProps({
  product: Object
})

const {t} = useI18n()
const cartStore = useCartStore()
const authStore = useAuthStore()

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const orderUuid = computed(() => {
  return cartStore.currentOrder ? cartStore.currentOrder.uuid : null
})
const productQuantity = computed(() => {
  return cartStore.currentOrder?.orderProducts?.edges.filter((prod) => prod.node.product.uuid === props.product.product.uuid)[0].node.quantity
})

const addProductToCart = async () => {
  const isProductInCart = cartStore.currentOrder?.orderProducts?.edges.find((prod) => prod.node.product.uuid === props.product.product.uuid)

  if (isProductInCart) {
    if (props.product.product.quantity > productQuantity.value) {
      const res = await Orders.overwriteCart("addOrderProduct", accessToken.value, orderUuid.value, props.product.product.uuid);
      cartStore.setCurrentOrders(res.data.addOrderProduct.order)

      if (res.errors) {
        ElNotification({
          title: t('popup.error'),
          message: res.errors[0].message,
          type: 'error'
        })
      } else {
        ElNotification({
          message: t('popup.addToCart', { product: props.product.product.name }),
          type: 'success'
        })
      }
    } else {
      ElNotification({
        title: t('popup.error'),
        message: t('popup.addToCartLimit', { quantity: props.product.product.quantity }),
        type: 'error'
      })
    }
  } else {
    const res = await Orders.overwriteCart("addOrderProduct", accessToken.value, orderUuid.value, props.product.product.uuid);

    if (res.errors) {
      ElNotification({
        title: t('popup.error'),
        message: res.errors[0].message,
        type: 'error'
      })
    } else {
      cartStore.setCurrentOrders(res.data.addOrderProduct?.order)

      ElNotification({
        message: t('popup.addToCart', { product: props.product.product.name }),
        type: 'success'
      })
    }
  }
}
const removeProductFormCart = async () => {
  if (productQuantity.value === 1) {
    await removeAllProductFormCart()
    return
  }

  const res = await Orders.overwriteCart("removeOrderProduct", accessToken.value, orderUuid.value, props.product.product.uuid);

  if (!res.errors) {
    cartStore.setCurrentOrders(res.data.removeOrderProduct.order)
  }
}
const removeAllProductFormCart = async () => {
  const res = await Orders.overwriteCart("removeOrderProductsOfAKind", accessToken.value, orderUuid.value, props.product.product.uuid);
  if (!res.errors) {
    cartStore.setCurrentOrders(res.data.removeOrderProductsOfAKind.order)
  }
}
</script>

<style lang="scss" scoped>
.table {
  &__column {
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 30%;
    }
    &:nth-child(3) {
      width: 15%;
    }
    &:nth-child(4) {
      width: 30%;
      display: flex;
      justify-content: center;
    }
    &:nth-child(5) {
      width: 15%;
      display: flex;
      justify-content: flex-end;
    }

    & svg {
      cursor: pointer;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 15px 10px;
    border-bottom: 2px solid #E8E8E8;
  }

  &__info {
    display: flex;
    align-items: center;
    gap: 15px;

    & img {
      border-radius: 7px;
      width: 65px;
      height: 80px;
      object-fit: cover;
    }

    & p {
      color: #2F2F2F;
      font-size: 14px;
      font-weight: 700;
      line-height: 25.6px;
    }
  }

  &__tools {
    width: fit-content;
    border: 1px solid #E8E8E8;
    border-radius: 5px;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    height: 42px;

    &-item {
      display: grid;
      place-items: center;
      width: 100%;
      height: 100%;

      color: #2F2F2F;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 25.6px;
    }

    &-count {
      border-left: 1px solid #E8E8E8;
      border-right: 1px solid #E8E8E8;
    }

    &-button {
      width: 20px;
      background-color: transparent;
      cursor: pointer;
      transition: 0.2s;

      @include hover {
        background-color: #E8E8E8;
      }
    }
  }
}
</style>